import { RecipeVariant, sva } from 'styled-system/css';

const toast = sva({
  slots: ['body', 'closeIcon', 'alertIconBackground'],
  base: {
    body: {
      width: '90%',
      maxWidth: 'maxContainer',
      mx: 'auto',
      marginTop: '16px',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '8px',
      padding: '16px',
      border: '1px solid',
      opacity: '0',
      transition: 'all .3s',
    },
    alertIconBackground: {
      padding: '5px',
      width: '25px',
      height: '25px',
    },
    closeIcon: {
      width: '20px',
      height: '20px',
    },
  },
  variants: {
    type: {
      error: {
        body: {
          backgroundColor: 'red-2',
          borderColor: 'red',
        },
        alertIconBackground: {
          backgroundColor: 'red',
        },
        closeIcon: {
          stroke: 'red',
        },
      },
      success: {
        body: {
          backgroundColor: 'green-4',
          borderColor: 'green',
        },
        alertIconBackground: {
          backgroundColor: 'green-2',
        },
        closeIcon: {
          stroke: 'green-2',
        },
      },
      warning: {
        body: {
          backgroundColor: 'orange-3',
          borderColor: 'orange',
        },
        alertIconBackground: {
          backgroundColor: 'orange',
        },
        closeIcon: {
          stroke: 'orange',
        },
      },
      info: {
        body: {
          backgroundColor: 'blue-2',
          borderColor: 'blue',
        },
        alertIconBackground: {
          backgroundColor: 'blue',
        },
        closeIcon: {
          stroke: 'blue',
        },
      },
    },
    show: {
      true: {
        body: {
          opacity: '1',
        },
      },
    },
  },
});

export default toast;

export type ToastTypes = RecipeVariant<typeof toast>['type'];
